import { postObject } from "../ChoiceApi"
import {ApprovalRespModel } from "../Models/SignatureRespModel";

export async function approveForIdMe(credentialId: number, enabled: string, message: string, errorCallback?: (errorMessage?: string) => void): Promise<ApprovalRespModel|undefined>
{
    const approvalResp = await postObject<ApprovalRespModel>("api/IdMe/V2/ApprovalMessage", {credentialId, enabled, message});
  
    return approvalResp;
}        
